import React from 'react';
import { HOURS } from './utils';

export default function SlotPicker({ avail, daySel, onToggleSlot }) {
  return (
    <div className="option-group">
      {HOURS.map((h) => (
        <span
          key={h}
          className={`option ${avail[daySel]?.includes(h) ? 'selected' : ''}`}
          onClick={() => onToggleSlot(h)}
        >
          {h}
        </span>
      ))}
    </div>
  );
}
